import classNames from "classnames";
import * as React from "react";
import { DoorIconProps } from "./DeKaap";

export const DeBeursDeMaas: React.FC<DoorIconProps> = ({
  isActive = false,
}) => {
  return (
    <svg
      width={28}
      height={60}
      viewBox="0 0 28 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={classNames("gg-transition gg-duration-150 gg-ease-in-out", {
          "gg-fill-[#292747]": isActive,
          "gg-fill-[#9493A3]": !isActive,
        })}
        d="M27.273 0v60H0V0zM2 58h23.27v-7H2zm0-8h23.27v-3.114C16.548 45.892 9.772 38.488 9.772 29.5s6.776-16.393 15.498-17.387V9.32H2zm23.27-36.88c-8.169.989-14.497 7.945-14.497 16.38s6.329 15.39 14.497 16.379zM2 8.32h23.27V2H2z"
        fill="#9493A3"
      />
    </svg>
  );
};
